// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-nhs-tsx": () => import("./../../../src/pages/nhs.tsx" /* webpackChunkName: "component---src-pages-nhs-tsx" */),
  "component---src-pages-supplier-tsx": () => import("./../../../src/pages/supplier.tsx" /* webpackChunkName: "component---src-pages-supplier-tsx" */)
}

